module.exports = __webpack_public_path__ + "static/img/a003.63a3904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a003.jpg
// module id = thF/
// module chunks = 0